import { useState } from "react";
import { toast } from "sonner";
import { FileText, Check, XCircle, HandCoins, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, API } from "@/lib/api";

export const QuoteActions = ({ q, quoteId, action }) => {
  const [rejectReason, setRejectReason] = useState("");
  const [showReject, setShowReject] = useState(false);

  return (
    <div>
      <h3 className="text-xs font-bold uppercase tracking-widest text-[#C85A32] mb-2">Azioni</h3>
      <div className="flex flex-wrap gap-2">
        {["nuovo", "in_revisione"].includes(q.status) && (
          <>
            <Button data-testid="approve-button" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => action(() => api.post(`/admin/quotes/${quoteId}/approve`), "Approvato — PDF generato e email inviata (mock)")}>
              <Check className="w-4 h-4 mr-1" /> Approva
            </Button>
            <Button data-testid="review-button" variant="outline" className="border-slate-600 text-slate-900" onClick={() => action(() => api.post(`/admin/quotes/${quoteId}/status`, { status: "in_revisione" }), "In revisione")}>In revisione</Button>
            <Button data-testid="reject-button" variant="outline" className="border-rose-700 text-rose-500" onClick={() => setShowReject(!showReject)}>
              <XCircle className="w-4 h-4 mr-1" /> Rifiuta
            </Button>
          </>
        )}
        {q.status === "approvato" && (
          <Button data-testid="deposit-received-button" className="bg-indigo-600 hover:bg-indigo-700" onClick={() => action(() => api.post(`/admin/quotes/${quoteId}/status`, { status: "confermato" }), "Acconto registrato — evento confermato!")}>
            <HandCoins className="w-4 h-4 mr-1" /> Acconto ricevuto → Conferma
          </Button>
        )}
        {q.status === "confermato" && (
          <Button data-testid="complete-button" variant="outline" className="border-slate-600 text-slate-900" onClick={() => action(() => api.post(`/admin/quotes/${quoteId}/status`, { status: "completato" }), "Evento completato")}>Segna completato</Button>
        )}
        {["approvato", "acconto_ricevuto", "confermato", "completato"].includes(q.status) && (
          <>
            <a data-testid="quote-pdf-link" href={`${API}/quotes/${q.id}/pdf`} target="_blank" rel="noreferrer">
              <Button variant="outline" className="border-slate-600 text-slate-900"><FileText className="w-4 h-4 mr-1" /> PDF preventivo</Button>
            </a>
            <Button data-testid="copy-confirm-link" variant="outline" className="border-slate-600 text-slate-900" onClick={() => {
              navigator.clipboard.writeText(`${window.location.origin}/conferma/${q.resume_token}`);
              toast.success("Link conferma copiato — invialo al cliente su WhatsApp per fargli accettare il preventivo");
            }}><Copy className="w-4 h-4 mr-1" /> Link conferma cliente</Button>
          </>
        )}
      </div>
      {showReject && (
        <div className="mt-3 flex gap-2">
          <Input data-testid="reject-reason-input" placeholder="Motivo del rifiuto…" className="bg-[#1E293B] border-slate-700 text-white" value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} />
          <Button data-testid="reject-confirm-button" className="bg-rose-600 hover:bg-rose-700" onClick={() => action(() => api.post(`/admin/quotes/${quoteId}/status`, { status: "rifiutato", reason: rejectReason }), "Preventivo rifiutato")}>Conferma</Button>
        </div>
      )}
    </div>
  );
};
